import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, fileUrl } from "@/lib/api";

const FontsContext = createContext({ fonts: [], reload: () => {} });
export const useFonts = () => useContext(FontsContext);

export function FontsProvider({ children }) {
  const [fonts, setFonts] = useState([]);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/fonts");
      setFonts(Array.isArray(data) ? data : []);
    } catch (e) {
      /* not fatal for the app */
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    const id = "bhf-custom-fonts";
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("style");
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = fonts
      .map((f) => `@font-face{font-family:'${String(f.family).replace(/'/g, "")}';src:url('${fileUrl(f.url)}');font-display:swap;}`)
      .join("\n");
  }, [fonts]);

  return <FontsContext.Provider value={{ fonts, reload }}>{children}</FontsContext.Provider>;
}
